import React, { FC } from 'react';
import { useGuideCmsContext } from '../GuideCmsContext';
import { Threads } from './tiptapComments/Threads';
import { TableOfContents } from './tableOfContents/TableOfContents';
import { Help } from './help/Help';
import References from './references/ReferencesSidebar';
import { FiguresSidebar } from './figures/FiguresSidebar';
import { DictionarySidebar } from './dictionary/DictionarySidebar';

export const Sidebar: FC = () => {
  const { sidebarType, editor, isSidebarOpen } = useGuideCmsContext();
  if (!editor || !isSidebarOpen) {
    return null;
  }

  switch (sidebarType) {
    case 'toc':
      return <TableOfContents editor={editor} />;
    case 'comments':
      return <Threads />;
    case 'references':
      return <References />;
    case 'figures':
      return <FiguresSidebar />;
    case 'dictionary':
      return <DictionarySidebar editor={editor} />;
    case 'help':
      return <Help />;
    default:
      return <div>Invalid sidebar type: {sidebarType}</div>;
  }
};
